export default "__VITE_ASSET__D3uuQF9i__"